import { render, staticRenderFns } from "./PointPayment.vue?vue&type=template&id=05329012"
import script from "./PointPayment.vue?vue&type=script&lang=js"
export * from "./PointPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports